import { render, staticRenderFns } from "./ChipListDisplay.vue?vue&type=template&id=c274f1a0&scoped=true"
import script from "./ChipListDisplay.vue?vue&type=script&lang=js"
export * from "./ChipListDisplay.vue?vue&type=script&lang=js"
import style0 from "./ChipListDisplay.vue?vue&type=style&index=0&id=c274f1a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c274f1a0",
  null
  
)

export default component.exports